export const getToTime = () => {
    const currentTimestamp = Math.floor(Date.now() / 1000);
    const threeHoursInSeconds = 6 * 60 * 60;
    const toTime = currentTimestamp + threeHoursInSeconds
    console.log(toTime)
    return toTime
}